export default {
    setAvatar(state, payload) {
        state.avatar = payload.avatar;
    },
    setName(state, payload) {
        state.name = payload.name;
    },
}